module.exports = __webpack_public_path__ + "img/loading.966cc54e.gif";